// src/store/rootSaga.ts
import { papersSaga } from "./papers/sagas";
import { all } from "redux-saga/effects";
import { authSaga } from "store/auth/sagas";
import { settingSaga } from "./settings/saga";
import { roundsSaga } from "./round/sagas";
import { vouchersSaga } from "./vouchers/sagas";
import { customersSaga } from "./customers/sagas";
import { branchesSaga } from "./branch/sagas";
import { usersSaga } from "./users/saga";
import { rolesSaga } from "./roles/saga";
import { holidaysSaga } from "./holidays/sagas";
import { paymentsSaga } from "./payments/sagas";
import { reportsSaga } from "./reports/sagas";
import { dashboardSaga } from "./dashboard/sagas";
import { additionalPapersSaga } from "./additional-papers/sagas";
import { deliveryDetailsSaga } from "./delivery-fees/sagas";

export function* rootSaga() {
  yield all([
    authSaga(),
    settingSaga(),
    papersSaga(),
    roundsSaga(),
    vouchersSaga(),
    customersSaga(),
    branchesSaga(),
    usersSaga(),
    rolesSaga(),
    holidaysSaga(),
    paymentsSaga(),
    reportsSaga(),
    dashboardSaga(),
    additionalPapersSaga(),
    deliveryDetailsSaga(),
  ]);
}
